import React, { useState, createContext } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Inventory from './pages/Inventory';
import AddVehicle from './pages/AddVehicle';
import Customers from './pages/Customers';
import Deals from './pages/Deals';
import Import from './pages/Import';
import Feed from './pages/Feed';
import Reports from './pages/Reports';
import Users from './pages/Users';
import Settings from './pages/Settings';
import LotTag from './pages/LotTag';
import './App.css';
export const UserContext = createContext(null);

export default function App() {
  const [user, setUser] = useState(() => JSON.parse(localStorage.getItem('rz_user') || 'null'));
  const [token, setToken] = useState(() => localStorage.getItem('rz_token'));

  const login = (token, user) => {
    localStorage.setItem('rz_token', token);
    localStorage.setItem('rz_user', JSON.stringify(user));
    setToken(token);
    setUser(user);
  };

  const logout = () => {
    localStorage.removeItem('rz_token');
    localStorage.removeItem('rz_user');
    setToken(null);
    setUser(null);
  };

  if (!token || !user) return <Login onLogin={login} />;
  const isAdmin = user?.role === 'admin';
  const isManager = user?.role === 'admin' || user?.role === 'manager';

  const returnToAdmin = () => {
    const adminToken = localStorage.getItem('rz_admin_return_token');
    const adminUser = localStorage.getItem('rz_admin_return_user');
    if (adminToken) {
      localStorage.removeItem('rz_admin_return_token');
      localStorage.removeItem('rz_admin_return_user');
      localStorage.removeItem('rz_token');
      localStorage.removeItem('rz_user');
      window.location.href = '/admin.html';
    }
  };

  return (
    <BrowserRouter>
      <UserContext.Provider value={{ user, isAdmin, isManager }}>
      <div style={{ display: 'flex', minHeight: '100vh' }}>
        <Sidebar user={user} onLogout={logout} />
        <div className="main-content" style={{ marginLeft: 220, flex: 1, padding: 28, background: '#0f0f0f', minHeight: '100vh' }}>
          {user?.impersonating && (
            <div style={{ background: '#2a1a33', border: '1px solid #9966ff', borderRadius: 8, padding: '10px 16px', marginBottom: 20, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span style={{ color: '#9966ff', fontSize: 13 }}>👁️ You are viewing as <strong>{user.dealer_name}</strong> — changes are real</span>
              <button onClick={returnToAdmin} style={{ padding: '6px 14px', background: '#9966ff', border: 'none', borderRadius: 6, color: '#fff', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>Return to Admin</button>
            </div>
          )}
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/inventory" element={<Inventory />} />
            <Route path="/vehicles/add" element={<AddVehicle />} />
            <Route path="/vehicles/edit/:id" element={<AddVehicle />} />
            <Route path="/customers" element={isManager ? <Customers /> : <Navigate to="/" />} />
            <Route path="/deals" element={isManager ? <Deals /> : <Navigate to="/" />} />
            <Route path="/import" element={isManager ? <Import /> : <Navigate to="/" />} />
            <Route path="/feed" element={isAdmin ? <Feed user={user} /> : <Navigate to="/" />} />
            <Route path="/reports" element={isManager ? <Reports /> : <Navigate to="/" />} />
            <Route path="/users" element={isAdmin ? <Users /> : <Navigate to="/" />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/vehicles/tag/:id" element={<LotTag />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
      </div>
      </UserContext.Provider>
    </BrowserRouter>
  );
}
